/** Inline SVG for a DealHunt spec `icon` name, with a generic fallback. */
const PATHS: Record<string, JSX.Element> = {
  battery: (
    <>
      <rect x="2" y="7" width="16" height="10" rx="2.5" />
      <rect x="4.5" y="9.5" width="7" height="5" rx="1" fill="currentColor" stroke="none" />
      <path d="M21 10v4" strokeLinecap="round" />
    </>
  ),
  barcode: (
    <>
      <rect x="2" y="7" width="16" height="10" rx="2.5" />
      <path d="M21 10v4" strokeLinecap="round" />
    </>
  ),
  charger: <path d="M13 2L4.5 13.5H11l-1 8.5L19.5 10H13z" fill="currentColor" stroke="none" />,
  drop: <path d="M12 3s6 6.4 6 10.2A6 6 0 0 1 6 13.2C6 9.4 12 3 12 3z" strokeLinejoin="round" />,
  headphones: (
    <>
      <path d="M4 13v-1a8 8 0 0 1 16 0v1" />
      <rect x="2.5" y="13" width="4" height="7" rx="1.6" />
      <rect x="17.5" y="13" width="4" height="7" rx="1.6" />
    </>
  ),
  network_bars: <path d="M4 9v6M8 6v12M12 3v18M16 7v10M20 10v4" strokeLinecap="round" />,
  noisy: <path d="M4 9v6M8 6v12M12 3v18M16 7v10M20 10v4" strokeLinecap="round" />,
}

const FALLBACK = (
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8h.01M11 12h1v4h1" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

const SpecIcon: React.VFC<{ name: string | null; className?: string }> = ({ name, className }) => (
  <svg
    className={className}
    width="21"
    height="21"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden="true"
  >
    {(name && PATHS[name]) || FALLBACK}
  </svg>
)

export default SpecIcon
